import { GetScenarioMetricsQuery } from "generated/graphql";
import _ from "lodash";

export interface ScenarioMetrics {
    sumAllocatedCost?: number;
    costPerMw?: number;
    sumAllocatedCostByConstraintType?: { [constraintType: string]: number };
    /**
     * Number of network upgrades with a non-zero allocated cost for the
     * project on this scenario. $0 contingent upgrades are excluded —
     * matching the Scenario Results page count (which also filters
     * `allocatedCost > 0`).
     */
    numAssignedUpgrades?: number;
    /**
     * Rank by $/MW within the scenario's pool, 1-indexed and ascending
     * so rank 1 is cheapest. Ties share a rank and skip the ones they
     * consume. Undefined when the scenario did not rank the project.
     */
    rank?: number;
    /** P1..P100 for {@link rank}. */
    rankPercentile?: number;
    /** Size of the pool {@link rank} was taken in. */
    totalRanked?: number;
}
export type ScenarioMetricsMapping = { [scenarioId: string]: ScenarioMetrics };

export const hasuraScenarioMetricsToScenarioMetricsMapping = (
    hasuraData: GetScenarioMetricsQuery
): ScenarioMetricsMapping => {
    return _.chain(hasuraData.scenarios)
        .keyBy("scenario_id")
        .mapValues((item) => {
            const sp = item.scenario_projects[0];
            return {
                sumAllocatedCost: sp?.sum_allocated_cost ?? undefined,
                costPerMw: sp?.cost_per_mw ?? undefined,
                sumAllocatedCostByConstraintType:
                    sp?.sum_allocated_cost_by_constraint_type ?? undefined,
                // De-dupe by network_upgrade_id: scenario_allocated_upgrades
                // is keyed by (network_upgrade_id, project_id, constraint_type),
                // so a single upgrade allocated under both ERIS and NRIS for the
                // same project arrives as two rows. We want to count distinct
                // upgrades, not allocation rows.
                numAssignedUpgrades: _.uniqBy(
                    item.scenario_allocated_upgrades,
                    "network_upgrade_id"
                ).length,
                rank: sp?.ranks?.rank,
                rankPercentile: sp?.ranks?.percentile,
                totalRanked: sp?.ranks?.total_ranked
            };
        })
        .value();
};
